/* eslint-disable @typescript-eslint/naming-convention */
import type { DetailsGrid, ItemBlock } from '@ps/web-martech-cms-types/DetailsGrid';
import classNames from 'clsx';
import React from 'react';

import {
  CMSBrightcoveVideo,
  CMSHTML,
  CMSHeading,
  CMSImage,
  CMSLinkedImage,
  CMSReference
} from '@swf/cms';

import sharedStyles from '../../styles/styles.scss';

import styles from './CMSDetailsGrid.scss';

const CMSDetailsGridItem: React.FC<ItemBlock & { alignment: DetailsGrid['item_alignment'] }> = ({
  title,
  image,
  body,
  link,
  alignment,
  brightcove_video: { video_id, player_id },
  reference
}) =>
  title || image.asset || body.content || link.url || reference ? (
    <article className={classNames(alignment && sharedStyles[alignment])}>
      {video_id && player_id && <CMSBrightcoveVideo video_id={video_id} player_id={player_id} />}
      {link.url ? (
        <CMSLinkedImage
          {...{
            link,
            image,
            animated: true,
            variant: null,
            className: styles.thumbnailImage
          }}
          logged_in_linked_image={{ link: link?.logged_in_link, image: image?.logged_in_image }}
        />
      ) : (
        <CMSImage {...image} className={styles.thumbnailImage} />
      )}
      <CMSHeading
        {...{
          title,
          level: 'h3',
          size: 'm',
          hero: false,
          url: link?.url,
          alignment
        }}
      />
      {body && <CMSHTML {...body} />}
      {!!reference?.length && <CMSReference {...reference[0]} />}
    </article>
  ) : null;

export default CMSDetailsGridItem;
